import { render, staticRenderFns } from "./workshop-feedback-stars.vue?vue&type=template&id=42991954&scoped=true"
import script from "./workshop-feedback-stars.vue?vue&type=script&lang=js"
export * from "./workshop-feedback-stars.vue?vue&type=script&lang=js"
import style0 from "./workshop-feedback-stars.vue?vue&type=style&index=0&id=42991954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42991954",
  null
  
)

export default component.exports